module.exports = __webpack_public_path__ + "img/environment_bathroom1.c5cc58c4.jpg";